/**
 * @param {string} text
 * @returns {string}
 */
export const cleanTextFromHtmlAndCss = (text) => {
  if (!text || typeof text !== 'string') {
    return '';
  }

  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = text;

  // textContent has already decoded entities once. Decoding a second time here
  // would double-unescape: "&amp;lt;" would come back as "<" instead of "&lt;".
  const cleanText = tempDiv.textContent || tempDiv.innerText || '';

  // "&nbsp;" is decoded to U+00A0 by the step above; normalize it to a plain space.
  return cleanText.replace(/\u00a0/g, ' ').trim();
};

/**
 * @param {Event} event
 * @param {Function} setValue
 * @param {Function} onChangeEvent
 * @param {string} id
 * @param {string} type
 */
export const handlePasteClean = (event, setValue, onChangeEvent, id, type) => {
  event.preventDefault();
  
  const clipboardData = event.clipboardData || window.clipboardData;
  const pastedText = clipboardData.getData('text/plain');
  const cleanText = cleanTextFromHtmlAndCss(pastedText);
  
  setValue(cleanText);
  
  if (onChangeEvent) {
    onChangeEvent(id, cleanText, type);
  }
};
